import React from 'react'
import SwitchMenuBar from '../../Components/SwitchMenuBar/SwitchMenuBar.js'
import './CommonContainerStyles.css'
import Tabs from '../../Components/Tabs/Tabs'

function CommonPageContainer(props) {
  const { header, tabs } = props
  return (
    <div className='page-container-outer'>
      <div className='menu-logo-bar'>
        <SwitchMenuBar isViewAsTeacher={false} />
      </div>
      <div className='page-container-main bg-photoregister'>
        <div className='bg-gradient page-container-bg'></div>
        {header && (
          <div className='page-container-header'>
            <div className='page-container-header-inner'>
              <h1>{header}</h1>
            </div>
          </div>
        )}
        {tabs ? (
          <div className='page-container-inner'>
            <Tabs tabs={tabs} />
            {props.children}
          </div>
        ) : (
          <div
            className={!header ? 'page-container-inner-without-header' : null}
          >
            {props.children}
          </div>
        )}
      </div>
    </div>
  )
}

export default CommonPageContainer
